const fileUploadurl = 'https://nexgen.sprintnxt.in/api/upload-normal-file';
const aesEnckey = '6fa979f20126cb08aa645a8f495f6d85';
const aesEnciv = 'I8zyA4lVhMCaJ5Kg';
const defEncKey = 'jy2hVH/mHvITAK&1Qs4udr1$NadtqwWT2SjdnSj2=';
const onboardurl = 'https://uatkyc.ciphersquare.in/kyc/front/#/kyc';
const NexgenInvoiceBackend = 'https://uat-invoice.sprintnxt.in/NexgenInvoiceBackendV1/';
// const NexgenInvoiceBackend = 'http://172.16.21.93:88/';
const seamLessPg = 'https://uat.sprintnxt.in/SeamlessPG/';
const domainName = 'uat.sprintnxt.in';
interface _InitEnv {
    environmentName: _Env_,
    production: boolean,
    domainName: string,
    frontend_url: string,
    baseurl: string,
    fileUploadurl: string,
    NexgenInvoiceBackend: string,
    seamLessPg: string,
    aesEnckey: string,
    aesEnciv: string,
    defEncKey: string,
    onboardurl: string,
    appVersion?: string,
}

type _Env_ = "production" | "preProd" | "uat" | "beta" | "preUat" | "onDemand";
interface _Env {
    production: _InitEnv,
    preProd: _InitEnv,
    uat: _InitEnv,
    beta: _InitEnv,
    preUat: _InitEnv,
    onDemand: _InitEnv,
}

let initial: _InitEnv = {
    environmentName: 'uat',
    baseurl: 'https://uat.sprintnxt.in/NexGenBackendV2/',
    frontend_url: 'https://uatnxtgen.sprintnxt.in/',
    production: false,
    domainName,
    fileUploadurl,
    aesEnckey,
    aesEnciv,
    defEncKey,
    onboardurl,
    NexgenInvoiceBackend,
    seamLessPg
}

let urls: Record<_Env_, _InitEnv> = {
    production: {
        ...initial,
        environmentName: 'production',
        production: true,
        domainName: 'nexgen.sprintnxt.in',
        frontend_url: 'https://nexgen.sprintnxt.in/',
        baseurl: 'https://beta.sprintnxt.in/NexGenBackendV2.1/',
        onboardurl: 'https://nxtverify.sprintnxt.in/#/kyc',
        appVersion: require('../../package.json').version,
        NexgenInvoiceBackend: 'https://invoice.sprintnxt.in/NexgenInvoiceBackendV1/'
    },
    beta: {
        ...initial,
        environmentName: 'beta',
        production: true,
        domainName: "nexgen.sprintnxt.in",
        frontend_url: 'https://beta.sprintnxt.in/',
        baseurl: 'https://beta.sprintnxt.in/NexGenBackendV2.1/',
        NexgenInvoiceBackend: 'https://invoice.sprintnxt.in/NexgenInvoiceBackendV1/'
    },
    preProd: {
        ...initial,
        environmentName: 'preProd',
        production: true,
        domainName: 'pre.sprintnxt.in',
        frontend_url: 'https://uatkyc.ciphersquare.in/',
        baseurl: 'https://uat.sprintnxt.in/PreNexGenBackendV2/',
        NexgenInvoiceBackend: 'https://uat-invoice.sprintnxt.in/PreNexgenInvoiceBackendV1/'
    },
    preUat: {
        ...initial,
        environmentName: 'preUat',
        production: true,
        domainName: "pre.sprintnxt.in",
        frontend_url: 'https://pre.sprintnxt.in/',
        baseurl: 'https://pre.sprintnxt.in/PreNexGenBackendV2/',
        NexgenInvoiceBackend: 'https://uat-invoice.sprintnxt.in/PreNexgenInvoiceBackendV1/'
    },
    uat: {
        ...initial,
        environmentName: 'uat',
        production: false,
        frontend_url: 'https://uatnxtgen.sprintnxt.in/',
        // baseurl: 'http://172.16.21.93:91/',
        appVersion: require('../../package.json').version + '-dev',
    },
    onDemand: {
        ...initial,
        environmentName: 'onDemand',
        production: true,
        domainName: "nexgen.sprintnxt.in",
        frontend_url: 'https://beta.sprintnxt.in/',
        baseurl: 'https://beta.sprintnxt.in/NexGenBackendV2/',
        NexgenInvoiceBackend: 'https://invoice.sprintnxt.in/NexgenInvoiceBackendV1'
    },
}

export default urls;